/**
 * Phase 18.7 — inline "Render the design on my photo" button.
 *
 * Rendered below an assistant message whose `offer_render` is true
 * (Stella emitted `[[OFFER_RENDER]]`). Tapping it sends a synthetic
 * user turn so Stella replies with a `[[RENDER:…]]` directive on her
 * next turn — same pattern as the NextStepPanel CTAs ("Show me
 * options", "Get my estimate"), just inline in chat.
 */

interface Props {
  onPress: () => void;
  disabled?: boolean;
  done?: boolean;
}

export function OfferRenderButton({ onPress, disabled, done }: Props) {
  if (done) {
    return (
      <div className="ml-1 mt-1 text-sm text-emerald-700">
        ✓ Render requested — Stella is working on it.
      </div>
    );
  }
  return (
    <div className="ml-1 mt-1">
      <button
        type="button"
        onClick={onPress}
        disabled={disabled}
        className="inline-flex items-center gap-2 rounded-full bg-starz-navy px-4 py-2 text-sm font-semibold text-starz-off-white disabled:opacity-50"
      >
        <svg
          aria-hidden="true"
          width="16"
          height="16"
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        >
          <rect x="3" y="3" width="18" height="18" rx="2" />
          <circle cx="9" cy="9" r="2" />
          <path d="m21 15-5-5L5 21" />
        </svg>
        Render the design on my photo
      </button>
    </div>
  );
}
